
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 77.99 72.42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#044ab7","d":"M0 0h77.99v72.42H0z"}}),_c('path',{attrs:{"fill":"#fbb03b","d":"M0 0h11.14v16.71H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M11.14 0h11.14v16.71H11.14z"}}),_c('path',{attrs:{"fill":"#fbb03b","d":"M22.28 0h11.14v16.71H22.28z"}}),_c('path',{attrs:{"fill":"#fff","d":"M33.43 0h11.14v16.71H33.43z"}}),_c('path',{attrs:{"fill":"#fbb03b","d":"M44.57 0h11.14v16.71H44.57zm22.28 0h11.14v16.71H66.85z"}}),_c('path',{attrs:{"fill":"#fff","d":"M55.71 0h11.14v16.71H55.71z"}}),_c('path',{attrs:{"fill":"#c9eaf4","d":"M39 33.43h33.43v22.28H39zm-27.86 0h16.71v39H11.14z"}})])
          )
        }
      }
    